/**
 * HTML内容安全处理工具
 * 用于防止XSS攻击
 */

/**
 * 简单的HTML标签过滤（基础防护）
 * 对于复杂场景，建议使用DOMPurify库
 * @param {string} html - 需要处理的HTML字符串
 * @returns {string} 处理后的安全HTML字符串
 */
export function sanitizeHtml(html) {
	if (!html || typeof html !== 'string') {
		return ''
	}

	// 移除危险的标签和属性
	const dangerousTags = ['script', 'iframe', 'object', 'embed', 'link', 'style', 'meta']
	const dangerousAttrs = ['onerror', 'onload', 'onclick', 'onmouseover', 'javascript:', 'data:text/html']

	let sanitized = html

	// 移除危险标签
	dangerousTags.forEach(tag => {
		const regex = new RegExp(`<${tag}[^>]*>.*?</${tag}>`, 'gis')
		sanitized = sanitized.replace(regex, '')
	})

	// 移除危险属性
	dangerousAttrs.forEach(attr => {
		const regex = new RegExp(`${attr}[^>]*`, 'gi')
		sanitized = sanitized.replace(regex, '')
	})

	return sanitized
}

/**
 * 将HTML转换为纯文本（最安全的方式）
 * @param {string} html - HTML字符串
 * @returns {string} 纯文本
 */
export function htmlToText(html) {
	if (!html || typeof html !== 'string') {
		return ''
	}

	// 创建临时DOM元素
	const tempDiv = document.createElement('div')
	tempDiv.innerHTML = html
	return tempDiv.textContent || tempDiv.innerText || ''
}

/**
 * 安全渲染HTML内容
 * 优先使用文本渲染，如果必须渲染HTML，则进行净化
 * @param {string} html - HTML字符串
 * @param {boolean} allowHtml - 是否允许HTML（默认false，使用纯文本）
 * @returns {string} 安全的HTML或文本
 */
export function safeRenderHtml(html, allowHtml = false) {
	if (!html || typeof html !== 'string') {
		return ''
	}

	if (allowHtml) {
		// 如果必须渲染HTML，进行净化处理
		return sanitizeHtml(html)
	} else {
		// 默认转换为纯文本（最安全）
		return htmlToText(html)
	}
}

